type Props = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    umami?: { track: (name: string, props?: Props) => void };
  }
}

const pending: Array<[string, Props | undefined]> = [];
let flushTimer: number | undefined;
let initialized = false;

export function initAnalytics(websiteId: string, src = 'https://analytics.playkeg.com/script.js'): void {
  if (initialized || !websiteId) return;
  initialized = true;

  const script = document.createElement('script');
  script.defer = true;
  script.src = src;
  script.dataset.websiteId = websiteId;
  script.dataset.autoTrack = 'true';
  script.addEventListener('load', flush);
  document.head.append(script);

  flushTimer = window.setInterval(flush, 500);
  window.setTimeout(() => {
    if (flushTimer !== undefined) window.clearInterval(flushTimer);
    flushTimer = undefined;
  }, 60_000);
}

export function track(name: string, props?: Props): void {
  if (window.umami?.track) {
    window.umami.track(name, clean(props));
    return;
  }
  pending.push([name, clean(props)]);
}

function flush(): void {
  if (!window.umami?.track) return;
  while (pending.length) {
    const [name, props] = pending.shift()!;
    window.umami.track(name, props);
  }
  if (flushTimer !== undefined) window.clearInterval(flushTimer);
  flushTimer = undefined;
}

function clean(props?: Props): Props | undefined {
  if (!props) return undefined;
  return Object.fromEntries(Object.entries(props).filter((entry): entry is [string, string | number | boolean] => entry[1] !== undefined));
}
